import type { IntlShape } from 'react-intl'

import type { getEmployee_employee_organisation_portalContent } from 'Constants/graphql/queries/employee/__generated__/getEmployee'
import type { getOrganisation_organisation_portalContent } from 'Constants/graphql/queries/organisation/__generated__/getOrganisation'

export const getDashboardHeader = (
  intl: IntlShape,
  isGermanLanguageActive: boolean,
  portalContent:
    | getOrganisation_organisation_portalContent
    | getEmployee_employee_organisation_portalContent
    | null,
  defaultMessageId: string,
): string => {
  if (isGermanLanguageActive) {
    if (portalContent?.dashboardHeaderDE) {
      return portalContent.dashboardHeaderDE
    }
  } else if (portalContent?.dashboardHeaderEN) {
    return portalContent.dashboardHeaderEN
  }

  return intl.formatMessage({ id: defaultMessageId })
}

export const getDashboardSubtitle = (
  intl: IntlShape,
  isGermanLanguageActive: boolean,
  portalContent:
    | getOrganisation_organisation_portalContent
    | getEmployee_employee_organisation_portalContent
    | null,
  defaultMessageId: string,
): string => {
  if (isGermanLanguageActive) {
    if (portalContent?.dashboardSubtitleDE) {
      return portalContent.dashboardSubtitleDE
    }
  } else if (portalContent?.dashboardSubtitleEN) {
    return portalContent.dashboardSubtitleEN
  }

  return intl.formatMessage({ id: defaultMessageId })
}

export const getDashboardButton = (
  intl: IntlShape,
  isGermanLanguageActive: boolean,
  portalContent:
    | getOrganisation_organisation_portalContent
    | getEmployee_employee_organisation_portalContent
    | null,
  defaultMessageId: string,
): string => {
  if (isGermanLanguageActive) {
    if (portalContent?.dashboardButtonDE) {
      return portalContent.dashboardButtonDE
    }
  } else if (portalContent?.dashboardButtonEN) {
    return portalContent.dashboardButtonEN
  }

  return intl.formatMessage({ id: defaultMessageId })
}
